import { useMemo } from 'react';

export const useYearListings = (
  baseYear: number | string,
  options?: {
    yearsBack?: number;
    yearsForward?: number;
  }
) =>
  useMemo(() => {
    const listings: number[] = [];
    const year = Number(baseYear);
    for (let i = options?.yearsBack ?? 100; i > 0; i--) {
      listings.push(year - i);
    }
    listings.push(year);
    for (let i = 0; i < (options?.yearsForward ?? 30); i++) {
      listings.push(year + i + 1);
    }
    return listings;
  }, [baseYear]);
